
export default [
    {
        path: 'contabilidad',
        name: 'empresa.contabilidad.layout',
        component: () => import('@/views/empresa/contabilidad/EmpresaContabilidadLayout.vue'),

        children: [
            {
                path: '',
                name: 'empresa.contabilidad',

                component: () => import('@/views/empresa/contabilidad/EmpresaContabilidadHome.vue'),

            },

            {
                path: 'configuracion',
                name: 'empresa.contabilidad.configuracion',
                component: () => import('@/views/empresa/contabilidad/EmpresaContabilidadConfiguracion.vue'),
            },

            {
                path: 'lineas',
                name: 'empresa.contabilidad.lineas',
                component: () => import('@/views/empresa/contabilidad/EmpresaContabilidadLineas.vue'),
            },

            {
                path: 'reportes',
                name: 'empresa.contabilidadReportes',
                component: () => import('@/views/admin/sucursales/contabilidad/ContabilidadReportesHome.vue'),
            },

            {
                path: 'plancuentas',
                name: 'empresa.contabilidadPlanDeCuentas',
                component: () => import('@/views/empresa/contabilidad/EmpresaContabilidadPlanDeCuentas.vue'),
            },
              {
                path: 'contribuyentes',
                name: 'empresa.contabilidad.contribuyentes',
                component: () => import('@/views/empresa/contabilidad/contribuyentes/EmpresaContribuyentes.vue'),
            },
            
            {
                path: 'contribuyentes/registrar',
                name: 'empresa.contabilidad.contribuyentes.registrar',
                component: () => import('@/views/empresa/contabilidad/contribuyentes/EmpresaContribuyenteCreate.vue'),
            }

        ],
    },

];
